var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnumHaloCe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6794 9.93884V14.2933H68.0064",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9055 7.91083L73.186 9.26233V13.9933",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8479 7.91083L75.1299 9.26233V13.9933",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.79 7.91089L77.072 9.26239V13.9934",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7324 7.91089L79.0144 9.26239V13.9934",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6758 7.91089L80.9578 9.26239V13.9934",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.8996 13.9934V9.26239L82.6191 7.91089",
    fill: "#FAFAFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.554 6.25031L71.695 6.76481C71.695 6.76481 71.752 7.18781 72.9055 7.18781H82.384",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8398 6.55931V9.00881C63.8398 9.00881 63.9238 9.57131 64.7128 9.57131H67.6693C67.6693 9.57131 68.2888 9.54281 68.2888 8.78231V6.44531",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6539 11.4103C38.2023 11.4103 38.6469 10.9657 38.6469 10.4173C38.6469 9.8689 38.2023 9.42432 37.6539 9.42432C37.1055 9.42432 36.6609 9.8689 36.6609 10.4173C36.6609 10.9657 37.1055 11.4103 37.6539 11.4103Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6179 25.1428L59.5029 24.7483C59.5029 24.7483 61.3044 24.4948 61.7559 26.5918L62.2059 28.6888C62.2059 28.6888 62.0364 29.6143 61.2489 30.1933C60.4599 30.7723 59.3904 32.0113 59.5599 32.9128C59.7294 33.8143 60.0009 35.0533 60.0009 35.0533C60.0009 35.0533 60.1794 36.2353 59.2224 36.5173C58.2654 36.7993 57.6459 36.3478 57.5334 35.4478C57.4209 34.5478 57.5334 33.1948 57.3084 32.0698C57.0834 30.9433 56.6334 30.8308 56.4069 29.5363C56.1819 28.2418 56.6889 27.9598 56.4069 27.2278C56.1249 26.4958 55.6179 25.1443 55.6179 25.1443V25.1428Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0752 25.7773H54.5467",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4551 28.1908H54.9281",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9199 30.4783H55.3914",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3613 32.7163H55.8328",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8818 35.1238H56.3533",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0959 36.7288L55.9674 41.1418L67.0479 40.0648L69.358 36.7288",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4551 23.8468C53.4551 23.8468 58.9391 24.7483 61.2476 22.6078C63.5561 20.4673 63.4436 18.4753 63.4436 18.4753H53.9966",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7559 47.8363L63.0504 54.8758",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7344 46.6633L65.3304 54.8758",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.9859 5.34881H73.2999L70.5969 6.27731H51.9294L51.1689 5.68631L46.3539 3.74381C44.4114 2.47631 39.9339 2.89781 39.9339 2.89781H29.5449V5.77181L30.4584 6.25031L29.5449 7.54481V10.5853H31.6854V12.5488H29.5449V17.8288L30.2214 18.6103C30.2214 18.6103 34.7259 18.3283 36.4104 19.2388C38.0949 20.1493 38.3814 22.0678 38.3814 22.0678L38.9289 24.7378L38.2224 25.7773L38.0259 26.5918L39.0909 27.6478L41.7099 36.6853C41.7099 36.6853 42.4704 38.0998 43.2684 38.9338C44.0664 39.7678 45.6264 39.9868 45.6264 39.9868L47.8854 40.1203L54.5499 40.4143L55.9704 41.1388L56.4084 44.2018L55.3659 46.2283L56.4084 47.8333H58.7739L60.0024 54.8728L58.9149 55.4923L59.3889 58.0258L71.8959 56.8993L71.8449 54.6793L69.3624 42.4993L70.6014 41.4148L67.8144 26.1268L67.9494 22.8328L69.1659 20.5528L71.0544 19.5658L72.5604 18.7783L80.9079 17.9338L83.2734 15.7378V14.4988L84.1179 14.2918V9.31931L80.9919 5.34881H80.9859ZM52.0974 37.8688C52.0974 37.8688 50.3664 37.9528 46.8609 37.8688C43.3554 37.7848 43.5669 35.8423 43.5669 35.8423C43.5669 35.8423 41.5404 28.6198 41.0754 27.2263C40.6104 25.8328 40.6524 24.4813 40.6959 22.0318C40.7379 19.5823 42.7224 19.1593 42.7224 19.1593L43.8624 18.7798C45.0024 18.4003 45.6789 18.4843 45.6789 18.4843L48.3564 18.5968C48.3564 18.5968 49.4229 20.1313 48.9159 21.7078C48.4089 23.2843 46.4949 24.2983 46.4949 24.2983L46.7769 25.1998C46.7769 25.1998 49.0854 25.0303 50.0424 22.7218C50.9994 20.4133 50.5209 18.6883 50.5209 18.6883L52.6899 18.7798C52.6899 18.7798 53.6619 22.2853 53.6619 22.4113C53.6619 22.5373 52.7754 24.1423 52.7754 24.1423L55.0989 36.7273C54.6339 38.0368 52.1004 37.8673 52.1004 37.8673L52.0974 37.8688Z",
    fill: "#FAFAFB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1764 2.89935C33.1764 2.89935 33.2289 4.85385 33.2904 7.03485C33.3384 8.75385 33.3924 10.6138 33.4299 11.7688C33.5139 14.3878 36.1329 14.2183 36.1329 14.2183C36.1329 14.2183 37.1469 14.3878 39.0894 14.2183C41.0319 14.0488 41.4549 12.9508 41.4549 12.9508C41.4549 12.9508 41.4549 12.1903 41.9619 10.8388C42.4689 9.48735 44.4954 9.61335 44.4954 9.61335H51.1689V5.68485C51.1689 5.68485 48.7194 4.67085 46.3539 3.74235C43.9884 2.81385 40.6104 2.89785 40.6104 2.89785H29.5449V6.10785H30.5589L33.2649 6.10035",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5589 6.10782L29.5449 7.54632V10.5868H31.9104V12.5503H29.5449V17.8288L30.2199 18.6103H33.8514C33.8514 18.6103 37.6524 18.5263 38.3289 21.8203L39.0039 25.1143L37.9059 26.0428L38.1594 27.2248L39.0879 27.6478L41.7069 36.6853C41.7069 36.6853 42.6354 39.8953 46.3524 40.0633C50.0694 40.2328 54.0384 40.1473 55.8969 40.6543L56.4039 44.2018L55.3614 46.2283L56.4039 47.8333H62.4009C62.4009 47.8333 67.6374 43.1038 70.5939 41.4133L67.8069 26.1253C67.8069 26.1253 67.8909 22.8313 67.9764 22.5778C68.0619 22.3243 69.1584 20.5513 69.1584 20.5513L72.8754 18.6088L80.9004 17.9338L83.2659 15.7378V14.2918H84.1104V9.31932L80.9844 5.34882H73.2984L70.9329 6.27732H51.1674",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5205 18.6883L48.4805 18.6013",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6885 18.7799L53.998 18.4769C53.998 18.4769 53.8285 16.9649 55.8145 16.9649C57.8005 16.9649 60.334 16.7534 60.334 16.7534L60.6715 14.7689H67.387C67.387 14.7689 68.6125 14.3039 69.1615 15.6554C69.7105 17.0069 69.331 18.5114 73.681 18.4769",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7705 47.8364L59.999 54.8759L58.7705 55.2134L59.384 58.0289L71.891 56.9024V54.9314L69.3035 42.2399",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.891 54.9314L59.999 54.8759",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5208 18.6883C50.5208 18.6883 50.9993 20.4133 50.0423 22.7218C49.0853 25.0303 46.7768 25.1998 46.7768 25.1998L46.4948 24.2984C46.4948 24.2984 48.4088 23.2843 48.9158 21.7078C49.4228 20.1313 48.3563 18.5968 48.3563 18.5968L45.6788 18.4843C45.6788 18.4843 45.0038 18.4003 43.8623 18.7798L42.7223 19.1593C42.7223 19.1593 40.7378 19.5824 40.6958 22.0319C40.6538 24.4814 40.6118 25.8328 41.0753 27.2263C41.5403 28.6198 43.5668 35.8423 43.5668 35.8423C43.5668 35.8423 43.3553 37.7849 46.8608 37.8689C50.3663 37.9529 52.0973 37.8689 52.0973 37.8689C52.0973 37.8689 54.6308 38.0383 55.0958 36.7288L52.7723 24.1439C52.7723 24.1439 53.6588 22.5388 53.6588 22.4128C53.6588 22.2868 52.6868 18.7813 52.6868 18.7813L50.5178 18.6898L50.5208 18.6883Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnumHaloCe);
export default __webpack_public_path__ + "static/media/Magnum Halo CE.f1a9bdd3386cacda79adcaad9fce5b10.svg";
export { ForwardRef as ReactComponent };